var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileChangePassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 580,
    viewBox: "0 0 580 580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1572_5154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.093 151.953C418.912 188.089 474.387 212.716 494.111 254.138C513.735 295.561 497.508 353.585 463.162 390.195C428.816 426.71 376.452 441.796 327.842 453.411C279.248 465.116 234.529 473.325 204.632 455.959C174.72 438.505 159.624 395.408 137.357 356.513C115.09 317.738 85.5562 283.108 78.8586 240.748C72.1611 198.288 88.2942 147.904 122.451 109.972C156.702 71.946 209.066 46.2616 252.279 57.2293C295.402 68.1708 329.369 115.822 374.093 151.953Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.97 144.816L490.489 217.105L361.967 238.982L458.97 144.816Z",
    stroke: "#B6C6FC",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.639 241.461C346.639 187.306 345.586 132.82 273.919 132.82C208.497 132.82 202.942 208.062 202.61 235.079C202.279 262.496 193.659 278.402 182.934 290.671V420.62C218.385 452.691 266.195 483.804 289.263 483.804C310.234 483.804 349.145 469.098 380.79 451.001V321.289C362.725 300.022 346.639 275.807 346.639 241.461Z",
    fill: "#FB5D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.767 354.318C138.515 295.783 198.035 304.466 198.951 231.414C199.099 219.62 200.236 198.637 206.918 178.734",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.918 413.367C398.929 442.363 319.207 480.158 285.598 480.158C258.808 480.158 198.651 438.172 163.226 401.488",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.229 311.723C393.148 337.728 418.675 358.642 425.104 386.528",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.426 144.806C237.63 135.329 251.468 129.152 270.233 129.152C341.911 129.152 342.953 183.638 342.953 237.793C342.953 260.96 350.293 279.557 360.624 295.712",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.934 457.679C182.955 465.89 186.225 473.759 192.031 479.565C197.836 485.372 205.704 488.644 213.915 488.666H349.809C358.02 488.644 365.888 485.372 371.693 479.565C377.499 473.759 380.769 465.89 380.79 457.679V392.315C357.623 349.013 320.307 320.906 278.216 320.906C240.305 320.906 206.249 343.726 182.913 379.915L182.934 457.679Z",
    fill: "#46DBC9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.426 414.414C76.426 407.707 78.4151 401.15 82.1416 395.573C85.8681 389.995 91.1648 385.648 97.3618 383.082C103.559 380.515 110.378 379.843 116.957 381.152C123.535 382.46 129.578 385.69 134.321 390.433C139.064 395.176 142.294 401.219 143.603 407.798C144.911 414.377 144.24 421.196 141.673 427.393C139.106 433.59 134.759 438.886 129.182 442.613C123.605 446.339 117.048 448.328 110.34 448.328C101.346 448.327 92.7207 444.754 86.3608 438.394C80.001 432.034 76.4274 423.408 76.426 414.414V414.414Z",
    fill: "#EAEFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.438 -0.00101688L100.465 73.6719L165.281 128.194L227.254 54.5214L162.438 -0.00101688Z",
    stroke: "#B6C6FC",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.019 381.027C375.778 385.591 378.368 390.352 380.79 395.312",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.501 329.293C243.643 321.837 258.987 317.746 275.057 317.746C304.206 317.746 331.059 331.22 352.515 353.882",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.934 372.019C190.068 361.626 198.513 352.197 208.06 343.965",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.821 467.351C391.792 476.25 388.244 484.776 381.951 491.069C375.659 497.361 367.133 500.909 358.234 500.938H205.538C196.633 500.918 188.099 497.373 181.8 491.08C175.5 484.786 171.948 476.255 171.919 467.351V214.977",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.919 154.062V83.1424C171.948 74.2434 175.496 65.7171 181.788 59.4245C188.081 53.1319 196.607 49.5838 205.506 49.5547H358.202C367.106 49.5755 375.641 53.1199 381.94 59.4134C388.24 65.7069 391.792 74.2379 391.821 83.1424V391.203",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.57 481.001C190.234 478.1 187.558 474.517 185.724 470.494C183.889 466.471 182.938 462.102 182.934 457.681V92.7913C182.955 84.5805 186.225 76.7118 192.031 70.9054C197.836 65.0989 205.704 61.8269 213.915 61.8047H311.661",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.329 63.3125C365.554 65.343 370.98 69.2863 374.834 74.5806C378.687 79.875 380.772 86.2503 380.79 92.7985V457.688C380.769 465.899 377.499 473.768 371.693 479.574C365.888 485.381 358.02 488.653 349.809 488.675H256.817",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.678 61.8047C339.163 63.1178 339.411 64.5066 339.41 65.9064V66.554C339.4 69.7154 338.14 72.7446 335.905 74.98C333.669 77.2155 330.64 78.4756 327.479 78.4854H244.844",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.013 475.375H328.705",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.81 277.496C241.916 289.606 243.106 323.368 241.332 340.954C248.082 346.641 277.742 351.79 297.461 344.15C294.796 334.383 293.375 311.115 295.686 296.904C283.07 292.286 239.81 277.496 239.81 277.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.552 313.68C239.61 322.841 239.363 331.719 238.699 338.322C242.759 341.744 255.132 344.972 268.633 345.335",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.828 341.506C292.164 331.739 290.742 308.471 293.054 294.26C280.417 289.642 237.178 274.852 237.178 274.852C237.988 279.532 238.668 287.441 239.089 296.403",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.196 305.406C314.911 305.406 341.432 270.045 341.432 226.426C341.432 182.806 314.911 147.445 282.196 147.445C249.482 147.445 222.961 182.806 222.961 226.426C222.961 270.045 249.482 305.406 282.196 305.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.174 265.801C317.606 287.426 299.309 301.716 278.511 301.716C273.792 301.716 269.101 300.979 264.61 299.531",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.093 253.99C220.867 243.886 219.241 233.34 219.275 222.734C219.275 179.116 245.792 143.754 278.511 143.754C311.23 143.754 337.746 179.116 337.746 222.734C337.761 231.135 336.75 239.506 334.734 247.661",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.594 234.416C315.446 234.416 316.948 231.047 316.948 226.891C316.948 222.736 315.446 219.367 313.594 219.367C311.741 219.367 310.24 222.736 310.24 226.891C310.24 231.047 311.741 234.416 313.594 234.416Z",
    fill: "#1B3C87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.939 238.977C296.334 244.6 298.914 250.834 303.363 254.773",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.527 228.617C293.535 229.768 293.602 230.917 293.728 232.061",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.466 274.33C274.789 274.33 277.484 271.635 277.484 268.311C277.484 264.987 274.789 262.293 271.466 262.293C268.142 262.293 265.447 264.987 265.447 268.311C265.447 271.635 268.142 274.33 271.466 274.33Z",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.107 164.198C295.152 164.477 295.224 164.75 295.323 165.014C298.25 173.702 328.721 228.725 342.838 238.561C343.338 229.957 344.175 194.574 338.667 184.559C333.16 174.545 310.292 148.176 303.116 148.176C295.939 148.176 295.128 164.388 295.128 164.388",
    fill: "#FB5D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.72 220.98C329.32 224.612 332.143 228.08 335.171 231.364",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.948 161.035C291.992 161.314 292.065 161.587 292.164 161.851C294.012 167.327 306.807 191.221 319.544 210.598",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.071 147.451C309.071 152.717 261.03 243.776 236.525 256.507C226.436 263.231 207.007 265.632 207.007 260.351C207.007 255.07 216.374 164.521 236.314 154.175C256.254 143.829 285.529 131.834 309.071 147.451Z",
    fill: "#FB5D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.271 188.246C268.401 215.531 247.513 246.797 233.892 253.874C229.453 256.833 223.193 258.955 217.569 259.955",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.438 144.816C306.438 146.185 303.216 153.299 298.013 163.319",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.643 268.437C238.038 268.437 244.844 261.632 244.844 253.236C244.844 244.841 238.038 238.035 229.643 238.035C221.247 238.035 214.442 244.841 214.442 253.236C214.442 261.632 221.247 268.437 229.643 268.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.86 236.698C223.213 235.66 225.79 235.235 228.352 235.462C230.913 235.689 233.375 236.562 235.508 237.999",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.317 265.19C228.72 265.95 225.966 266.004 223.341 265.346C220.716 264.687 218.314 263.341 216.383 261.445C214.451 259.549 213.061 257.172 212.354 254.559C211.647 251.947 211.65 249.193 212.362 246.582",
    stroke: "#1B3C87",
    strokeWidth: 2.51684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.596 552.738L201.514 554.853L199.749 557.807L195.794 555.466L195.869 559.821H192.49V555.429L188.523 557.807L186.834 554.866L190.713 552.738L186.784 550.573L188.511 547.632L192.478 549.997V545.617H195.857L195.782 549.997L199.736 547.632L201.501 550.573L197.596 552.738Z",
    fill: "#B6C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.55 552.738L246.467 554.853L244.702 557.807L240.773 555.466V559.871H237.381V555.479L233.426 557.857L231.787 554.866L235.767 552.738L231.85 550.573L233.577 547.632L237.531 549.997V545.617H240.773L240.697 549.997L244.652 547.632L246.417 550.573L242.55 552.738Z",
    fill: "#B6C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.301 552.741L290.218 554.856L288.454 557.81L284.499 555.469L284.574 559.875H281.195V555.482L277.228 557.86L275.538 554.869L279.468 552.754L275.538 550.589L277.265 547.648L281.233 550.013V545.633H284.574L284.499 550.013L288.454 547.648L290.218 550.589L286.301 552.741Z",
    fill: "#B6C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.688 552.741L332.605 554.856L330.878 557.81L326.924 555.469L326.999 559.824H323.62V555.432L319.665 557.81L317.926 554.869L321.855 552.754L317.926 550.589L319.653 547.648L323.607 550.013V545.633H326.986L326.911 550.013L330.866 547.648L332.63 550.589L328.688 552.741Z",
    fill: "#B6C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.738 552.741L374.68 554.869L372.915 557.822L368.961 555.482L369.023 559.837H365.644V555.444L361.69 557.822L359.988 554.869L363.905 552.754L359.988 550.589L361.715 547.648L365.669 550.013V545.633H369.048L368.986 550.013L372.94 547.648L374.705 550.589L370.738 552.741Z",
    fill: "#B6C6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.567 579.996H185.607C183.262 579.993 181.013 579.06 179.355 577.401C177.696 575.743 176.763 573.494 176.76 571.148V537.484C176.763 535.139 177.697 532.892 179.355 531.235C181.014 529.579 183.263 528.648 185.607 528.648H204.567C206.912 528.648 209.16 529.579 210.819 531.235C212.478 532.892 213.412 535.139 213.415 537.484V571.136C213.415 573.484 212.483 575.735 210.824 577.397C209.166 579.058 206.915 579.993 204.567 579.996ZM185.607 529.274C183.429 529.274 181.34 530.139 179.798 531.678C178.256 533.217 177.389 535.305 177.385 537.484V571.136C177.389 573.315 178.256 575.405 179.797 576.946C181.338 578.487 183.428 579.355 185.607 579.358H204.567C206.748 579.358 208.839 578.492 210.381 576.95C211.923 575.408 212.789 573.316 212.789 571.136V537.471C212.786 535.293 211.918 533.205 210.377 531.665C208.835 530.126 206.746 529.262 204.567 529.262L185.607 529.274Z",
    fill: "#1B3C87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.607 579.997H229.647C228.48 580.002 227.324 579.777 226.245 579.333C225.165 578.89 224.184 578.239 223.357 577.415C222.531 576.592 221.875 575.614 221.427 574.536C220.979 573.459 220.749 572.303 220.749 571.137V537.472C220.752 535.128 221.686 532.88 223.345 531.224C225.004 529.567 227.252 528.637 229.597 528.637H248.557C250.901 528.637 253.15 529.567 254.809 531.224C256.468 532.88 257.401 535.128 257.405 537.472V571.137C257.405 573.476 256.48 575.72 254.832 577.38C253.183 579.04 250.946 579.981 248.607 579.997ZM229.647 529.275C227.468 529.275 225.379 530.14 223.837 531.679C222.296 533.218 221.428 535.306 221.425 537.485V571.137C221.428 573.316 222.295 575.406 223.837 576.947C225.378 578.488 227.467 579.356 229.647 579.359H248.607C250.787 579.359 252.879 578.493 254.421 576.951C255.963 575.409 256.829 573.317 256.829 571.137V537.472C256.826 535.294 255.958 533.206 254.416 531.666C252.875 530.127 250.785 529.262 248.607 529.262L229.647 529.275Z",
    fill: "#1B3C87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.445 579.996H272.472C270.127 579.993 267.878 579.06 266.22 577.401C264.561 575.743 263.628 573.494 263.624 571.148V537.484C263.628 535.139 264.561 532.892 266.22 531.235C267.879 529.579 270.128 528.648 272.472 528.648H291.445C293.787 528.652 296.032 529.584 297.689 531.24C299.345 532.896 300.277 535.142 300.28 537.484V571.136C300.282 572.298 300.055 573.449 299.611 574.523C299.168 575.597 298.518 576.573 297.697 577.396C296.877 578.219 295.903 578.872 294.83 579.318C293.757 579.764 292.607 579.995 291.445 579.996ZM272.472 529.274C270.294 529.274 268.204 530.139 266.663 531.678C265.121 533.217 264.254 535.305 264.25 537.484V571.136C264.253 573.315 265.121 575.405 266.662 576.946C268.203 578.487 270.293 579.355 272.472 579.358H291.445C293.623 579.355 295.711 578.487 297.251 576.945C298.79 575.404 299.654 573.314 299.654 571.136V537.471C299.654 535.294 298.789 533.206 297.25 531.666C295.71 530.127 293.622 529.262 291.445 529.262L272.472 529.274Z",
    fill: "#1B3C87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.758 579.996H315.786C313.44 579.993 311.191 579.06 309.533 577.401C307.874 575.743 306.941 573.494 306.938 571.148V537.484C306.941 535.139 307.875 532.892 309.534 531.235C311.193 529.579 313.441 528.648 315.786 528.648H334.758C337.1 528.652 339.346 529.584 341.002 531.24C342.658 532.896 343.59 535.142 343.593 537.484V571.136C343.595 572.298 343.368 573.449 342.925 574.523C342.482 575.597 341.831 576.573 341.011 577.396C340.19 578.219 339.216 578.872 338.143 579.318C337.07 579.764 335.92 579.995 334.758 579.996ZM315.786 529.274C313.607 529.274 311.518 530.139 309.976 531.678C308.435 533.217 307.567 535.305 307.563 537.484V571.136C307.567 573.315 308.434 575.405 309.975 576.946C311.517 578.487 313.606 579.355 315.786 579.358H334.758C336.937 579.355 339.025 578.487 340.564 576.945C342.103 575.404 342.968 573.314 342.968 571.136V537.471C342.968 535.294 342.103 533.206 340.563 531.666C339.024 530.127 336.935 529.262 334.758 529.262L315.786 529.274Z",
    fill: "#1B3C87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.808 579.996H357.848C355.502 579.993 353.254 579.06 351.595 577.401C349.936 575.743 349.003 573.494 349 571.148V537.484C349.003 535.139 349.937 532.892 351.596 531.235C353.255 529.579 355.503 528.648 357.848 528.648H376.808C379.152 528.648 381.401 529.579 383.06 531.235C384.718 532.892 385.652 535.139 385.655 537.484V571.136C385.655 573.484 384.724 575.735 383.065 577.397C381.406 579.058 379.155 579.993 376.808 579.996ZM357.848 529.274C355.669 529.274 353.58 530.139 352.038 531.678C350.497 533.217 349.629 535.305 349.626 537.484V571.136C349.626 573.316 350.492 575.408 352.034 576.95C353.576 578.492 355.667 579.358 357.848 579.358H376.808C378.987 579.355 381.077 578.487 382.618 576.946C384.159 575.405 385.026 573.315 385.03 571.136V537.471C385.026 535.293 384.159 533.205 382.617 531.665C381.075 530.126 378.986 529.262 376.808 529.262L357.848 529.274Z",
    fill: "#1B3C87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1572_5154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 580,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileChangePassword);
export default __webpack_public_path__ + "static/media/ProfileChangePassword.ea6d3d1f78821b02d99424911bb29b16.svg";
export { ForwardRef as ReactComponent };